// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#margin-dialog-body[data-v-2ea57a95] {\n    margin-top: 15px;\n    margin-right: 15px;\n    margin-bottom: 15px;\n    margin-left: 0px;\n}\n", ""]);
// Exports
module.exports = exports;
